/**
 * The gigs have pictures (Stage 684). The contracts desk listed each fixer's gigs as rows of text.
 * Each of the twelve now carries a thumbnail on its row, drawn in Higgsfield with the Blank from the
 * game's own figures: the escrow heists, the drone convoys, the wake-cell rescues and the sensor
 * sabotage, each in the district it is fought in. Keyed by gig id; the arc's missions lead with
 * their banner instead (missionart.ts).
 */
export const GIG_ART: Readonly<Record<string, string>> = {
  g_escrow_row: "/gigs/g_escrow_row.jpg",
  g_convoy_docks: "/gigs/g_convoy_docks.jpg",
  g_rescue_depot: "/gigs/g_rescue_depot.jpg",
  g_lattice_row: "/gigs/g_lattice_row.jpg",
  g_escrow_depot: "/gigs/g_escrow_depot.jpg",
  g_convoy_row: "/gigs/g_convoy_row.jpg",
  g_rescue_docks: "/gigs/g_rescue_docks.jpg",
  g_lattice_docks: "/gigs/g_lattice_docks.jpg",
  g_escrow_docks: "/gigs/g_escrow_docks.jpg",
  g_convoy_depot: "/gigs/g_convoy_depot.jpg",
  g_rescue_row: "/gigs/g_rescue_row.jpg",
  g_lattice_depot: "/gigs/g_lattice_depot.jpg",
  g_awning_cell: "/gigs/g_awning_cell.jpg",
  g_uplink_skim: "/gigs/g_uplink_skim.jpg",
  g_sluice_dark: "/gigs/g_sluice_dark.jpg",
  g_showroom_heat: "/gigs/g_showroom_heat.jpg",
  g_clinic_ledger: "/gigs/g_clinic_ledger.jpg",
  g_bonded_cold: "/gigs/g_bonded_cold.jpg",
  g_vespers: "/gigs/g_vespers.jpg",
  g_hot_pour: "/gigs/g_hot_pour.jpg",
  g_live_cable: "/gigs/g_live_cable.jpg",
  g_dark_fiber: "/gigs/g_dark_fiber.jpg",
  g_kiln_bisque: "/gigs/g_kiln_bisque.jpg",
  g_bale_cut: "/gigs/g_bale_cut.jpg",
  g_member_door: "/gigs/g_member_door.jpg",
  g_flake_deck: "/gigs/g_flake_deck.jpg",
  g_white_out: "/gigs/g_white_out.jpg",
  g_spare_shade: "/gigs/g_spare_shade.jpg",
  g_row_six: "/gigs/g_row_six.jpg",
  g_walkway_post: "/gigs/g_walkway_post.jpg",
  g_crane_quiet: "/gigs/g_crane_quiet.jpg",
  g_far_fence: "/gigs/g_far_fence.jpg",
  g_night_count: "/gigs/g_night_count.jpg",
  g_mast_walk: "/gigs/g_mast_walk.jpg",
  g_barge_shadow: "/gigs/g_barge_shadow.jpg",
  g_pane_skim: "/gigs/g_pane_skim.jpg",
  g_floor_count: "/gigs/g_floor_count.jpg",
  g_cold_walk: "/gigs/g_cold_walk.jpg",
  g_nave_skim: "/gigs/g_nave_skim.jpg",
  g_pour_posts: "/gigs/g_pour_posts.jpg",
  g_trellis_cell: "/gigs/g_trellis_cell.jpg",
  g_ping_dark: "/gigs/g_ping_dark.jpg",
  g_rake_heat: "/gigs/g_rake_heat.jpg",
  g_wharf_wake: "/gigs/g_wharf_wake.jpg",
  g_court_skim: "/gigs/g_court_skim.jpg",
  g_crown_posts: "/gigs/g_crown_posts.jpg",
  g_salt_cell: "/gigs/g_salt_cell.jpg",
  g_bazaar_rack: "/gigs/g_bazaar_rack.jpg",
  g_bill_posts: "/gigs/g_bill_posts.jpg",
  g_plaza_skim: "/gigs/g_plaza_skim.jpg",
  g_letter_hold: "/gigs/g_letter_hold.jpg",
  g_lot_dark: "/gigs/g_lot_dark.jpg",
  g_lantern_quiet: "/gigs/g_lantern_quiet.jpg",
  g_crown_leash: "/gigs/g_crown_leash.jpg",
  g_lock_ledger: "/gigs/g_lock_ledger.jpg",
  g_mile_dark: "/gigs/g_mile_dark.jpg",
  g_rib_walk: "/gigs/g_rib_walk.jpg",
  g_frost_rack: "/gigs/g_frost_rack.jpg",
  g_hymn_posts: "/gigs/g_hymn_posts.jpg",
  g_grate_cell: "/gigs/g_grate_cell.jpg",
  g_root_skim: "/gigs/g_root_skim.jpg",
  g_blank_dish: "/gigs/g_blank_dish.jpg",
  g_glaze_walk: "/gigs/g_glaze_walk.jpg",
  g_shear_quiet: "/gigs/g_shear_quiet.jpg",
  g_cover_cell: "/gigs/g_cover_cell.jpg",
  g_oxide_rack: "/gigs/g_oxide_rack.jpg",
  g_landing_dark: "/gigs/g_landing_dark.jpg",
  g_filament_cell: "/gigs/g_filament_cell.jpg",
  g_stem_ledger: "/gigs/g_stem_ledger.jpg",
  g_cage_file: "/gigs/g_cage_file.jpg",
  g_tide_rack: "/gigs/g_tide_rack.jpg",
  g_impound_walk: "/gigs/g_impound_walk.jpg",
  g_spice_crate: "/gigs/g_spice_crate.jpg",
  g_guy_wire: "/gigs/g_guy_wire.jpg",
  g_ash_weir: "/gigs/g_ash_weir.jpg",
  g_lintel_file: "/gigs/g_lintel_file.jpg",
  g_marrow_bin: "/gigs/g_marrow_bin.jpg",
  g_seal_break: "/gigs/g_seal_break.jpg",
  g_choir_wire: "/gigs/g_choir_wire.jpg",
  g_skim_ladle: "/gigs/g_skim_ladle.jpg",
  g_coil_quiet: "/gigs/g_coil_quiet.jpg",
  g_null_tape: "/gigs/g_null_tape.jpg",
  g_vent_sag: "/gigs/g_vent_sag.jpg",
  g_ink_barge: "/gigs/g_ink_barge.jpg",
  g_guest_book: "/gigs/g_guest_book.jpg",
  g_climb_cell: "/gigs/g_climb_cell.jpg",
  g_tread_count: "/gigs/g_tread_count.jpg",
  g_watt_shade: "/gigs/g_watt_shade.jpg",
  g_graft_walk: "/gigs/g_graft_walk.jpg",
  g_sleep_stair: "/gigs/g_sleep_stair.jpg",
  g_pier_witness: "/gigs/g_pier_witness.jpg",
  g_clamp_quiet: "/gigs/g_clamp_quiet.jpg",
  g_close_bell: "/gigs/g_close_bell.jpg",
  g_static_well: "/gigs/g_static_well.jpg",
  g_draft_mark: "/gigs/g_draft_mark.jpg",
  g_curtain_wall: "/gigs/g_curtain_wall.jpg",
  g_suture_rack: "/gigs/g_suture_rack.jpg",
  g_drip_tray: "/gigs/g_drip_tray.jpg",
  g_votive_row: "/gigs/g_votive_row.jpg",
  g_crucible_set: "/gigs/g_crucible_set.jpg",
};

/** the thumbnail a desk row leads with: the gig's own picture, or nothing for anything that is not a gig */
export function gigThumb(id: string): string {
  const src = GIG_ART[id];
  return src ? `<img class="gt" src="${src}" alt="">` : "";
}
